/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconExposurePlus2 = createReactComponent("outline", "exposure-plus-2", "IconExposurePlus2", [["path", { "d": "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8", "key": "svg-0" }], ["path", { "d": "M3 12h6", "key": "svg-1" }], ["path", { "d": "M6 9v6", "key": "svg-2" }]]);

export { IconExposurePlus2 as default };
//# sourceMappingURL=IconExposurePlus2.mjs.map
